<template>
    <div class="loginContainer" v-show="LoginShow">
        <section class="main clearfix">
            <i class="el-icon-close" @click="colse"></i>
            <div class="contFr fr">
                <el-form  v-if="loginType==1" style="width=400px" :model="ruleForm" ref="ruleForm" label-width="1px" class="demo-ruleForm">
                    <el-form-item label="" prop="userName" class="formItems" :rules='[
                    {required: true, message: "请输入手机号", trigger: "blur",},
                    {required: true, validator: isCellPhone, trigger: "blur",},]'>
                        <img class="iconfonts" src="@/assets/images/icon/phone1.png" alt="" />
                        <el-input class="input clearfix" placeholder="请输入您的手机号" maxlength="11" v-model="ruleForm.userName"></el-input>
                    </el-form-item>

                    <el-form-item label="" prop="loginCode" class="formItems1" style="margin-bottom:22px;" :rules='[
                    {required: true,message: "请输入计算结果",trigger: "blur",}]'>
                    <div class="clearfix">
                        <el-input class="input" placeholder="请输入图形验证码" v-model="ruleForm.loginCode"></el-input>
                    </div>
                    <img @click="getImgCodes" class="codeBox imgCode" :src="imgCode" alt="图形验证码" />
                    </el-form-item>

                    <el-form-item label="" prop="smsCode" class="formItems1" :rules='[{required: true,message: "请输入短信验证码",trigger: "blur",}]'>
                    <div class="clearfix">
                        <el-input class="input" placeholder="请输入短信验证码" v-model="ruleForm.smsCode"></el-input>
                    </div>
                    <span @click="getCode()" class="codeBox code">{{codeTxt}}</span>
                    </el-form-item>

                    <div class="cahngeLogin clearfix">
                        <span :class="[loginType==2?'active':'','fr']" @click="changeLoginType()">{{loginType==2?"验证码登录":"密码登录"}}</span>
                    </div>

                    <el-form-item style="margin-bottom:48px;margin-top:72px;">
                        <p class="register" type="primary" @click="submitForm('ruleForm')">登录账号</p>
                        <a class="goLogin" href="javascript:void(0)" @click="goLogin">未注册账号，去注册</a>
                    </el-form-item>

                    <!-- <div class="orStyle">
                        <span>或</span>
                    </div> -->

                    <!-- <div class="loginType">
                        <img class="icon" src="@/assets/images/icon/qq.png" alt="qq" />
                        <img class="icon" src="@/assets/images/icon/weixin.png" alt="weixin" />
                    </div> -->
                </el-form>

                <el-form v-else style="width=400px" :model="ruleForm" ref="ruleForm1" label-width="1px" class="demo-ruleForm">
                    <el-form-item label="" label-width="1" prop="userName" class="formItems" :rules='[
                    {required: true, message: "请输入手机号", trigger: "blur",},
                    {required: true, validator: isCellPhone, trigger: "blur",},]'>
                        <img class="iconfonts" src="@/assets/images/icon/phone1.png" alt="" />
                        <el-input class="input clearfix" placeholder="请输入您的手机号" maxlength="11" v-model="ruleForm.userName"></el-input>
                    </el-form-item>

                    <el-form-item label="" prop="passWord" class="formItems"
                    :rules='[{required: true,message: "请输入密码",trigger: "blur",},
                            {validator: validatePass,trigger: "blur",},
                            {min: 8,max: 12,message: "长度在8到12个字符",trigger: "blur",}]'>
                        <img class="iconfonts" src="@/assets/images/icon/paswd1.png" alt="" />
                        <el-input class="input" show-password placeholder="请输入登录密码" maxlength="12"
                            v-model="ruleForm.passWord"></el-input>
                    </el-form-item>

                    <el-form-item label="" prop="loginCode" class="formItems1" :rules='[
                    {required: true,message: "请输入计算结果",trigger: "blur",}]'>
                    <div class="clearfix">
                        <el-input class="input" placeholder="请输入图形验证码" v-model="ruleForm.loginCode"></el-input>
                    </div>
                    <img @click="getImgCodes" class="codeBox imgCode" :src="imgCode" alt="图形验证码" />
                    </el-form-item>

                    <div class="cahngeLogin clearfix">
                        <span class="fl" @click="forgtPass()">忘记密码？</span>
                        <span :class="[loginType==2?'active':'','fr']" @click="changeLoginType()">{{loginType==2?"验证码登录":"密码登录"}}</span>
                    </div>

                    <el-form-item style="margin-bottom:48px;margin-top:72px;">
                        <p class="register" type="primary" @click="submitForm('ruleForm1')">登录账号</p>
                        <a class="goLogin" href="javascript:void(0)" @click="goLogin">未注册账号，去注册</a>
                    </el-form-item>

                    <!-- <div class="orStyle">
                        <span>或</span>
                    </div> -->

                    <!-- <div class="loginType">
                        <img class="icon" src="@/assets/images/icon/qq.png" alt="qq" />
                        <img class="icon" src="@/assets/images/icon/weixin.png" alt="weixin" />
                    </div> -->
                </el-form>
            
            </div>
        </section>
        <Messages ref="messages" :tips="tipsTxt" />
    </div>
</template>

<script>
import { timestamp,isCellPhone} from "@/utils/proof-technique.js"
import {getLosinCode,userPaswrodLosin,userCodeLosin} from "@/api/index.js"
import Messages from "@/components/Messages"
import { mapState } from 'vuex';
export default {
  data() {
    let validatePass = (rule, value, callback) => {
		  let reg= /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*.]{8,15}$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      }else if(!reg.test(value)){
        callback(new Error('密码必须是由8-15位字母+数字组合'))
      } else {
        // if (this.ruleForm.repeatpassWord !== "") {
				// this.$refs.ruleForm.validateField("repeatpassWord");
        // }
        callback();
      }
    };
    return {
      tipsTxt:"",
      loginType:1,
      codeTxt:"获取验证码",
      isCellPhone:isCellPhone,
      validatePass:validatePass,
      imgCode:"",
      ruleForm: {
        userName:"",
        passWord:"",
        smsCode:"",
        userType:1,
        loginCode:null
      },
      flag:true,
      interval:null,
    }
  },
  components:{
    Messages,
  },
  methods: {
    colse(){
        this.$store.dispatch("ChangeLoginShow");
    },
    goLogin(){
      this.$store.dispatch("ChangeRegisShow");
      this.$store.dispatch("ChangeLoginShow");
    },
    forgtPass(){
      this.$store.dispatch("ChangeLoginShow");
      this.$store.dispatch("ChangeForgetPassShow");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.loginType==1){
            userCodeLosin(this.ruleForm).then(res=>{
              if(res.data.success){
                this.tipsTxt = "登录成功";
                this.$refs.messages.show = true;
                this.$store.dispatch("CutLogin");
                this.$store.dispatch("getuser");
                localStorage.setItem("token", res.data.obj.token);
                setTimeout(() => {
                  this.$store.dispatch("ChangeLoginShow");
                }, 800);
              }else{
                if(res.data.msg && res.data.msg!=""){
                  this.$message({
                    type: "warning",
                    message: res.data.msg,
                  });
                }
              }
            }).catch(err=>{
              console.log(err)
            });
          }else{
            let passw = this.ruleForm.passWord;
            passw = this.hrymd5.md5(passw);
            userPaswrodLosin({
              userName:this.ruleForm.userName,
              passWord:passw,
              smsCode:this.ruleForm.smsCode,
              userType:this.ruleForm.userType,
              loginCode:this.ruleForm.loginCode
            }).then(res=>{
              if(res.data.success){
                this.tipsTxt = "登录成功";
                this.$refs.messages.show = true;
                this.$store.dispatch("CutLogin");
                this.$store.dispatch("getuser");
                localStorage.setItem("token", res.data.obj.token);
                setTimeout(() => {
                  this.$store.dispatch("ChangeLoginShow");
                }, 800);
              }else{
                if(res.data.msg && res.data.msg!=""){
                  this.$message({
                    type: "warning",
                    message: res.data.msg,
                  });
                }
              }
            }).catch(err=>{
              console.log(err)
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getCodeApi(){
      if(this.ruleForm.loginCode == null || this.ruleForm.loginCode == ""){
        this.$message({
          type: "warning",
          message: "请输入图形验证码",
        });
        return;
      }
      getLosinCode({
        uid:this.timer,
        mobile:this.ruleForm.userName,
        viewCode:this.ruleForm.loginCode,
      }).then(res=>{
        if(res.data.success){
          let numB = 60;
          this.flag = false;
          this.$message({
            message: '验证码已发送，请注意查收',
            offset:300,
            type: 'success'
          });
          this.interval = setInterval(() => {
            numB--;
            this.codeTxt = numB + " S 后重新获取";
            if(numB == 0){
              clearInterval(this.interval);
              numB = 0;
              this.codeTxt = "获取验证码";
              this.flag = true;
            }
          }, 1000);
        }else{
          if(res.data.msg && res.data.msg!=""){
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        }
      }).catch(err=>{
        console.log(err)
      });
    },
    getCode(){
      let mobile = this.ruleForm.userName;
      if (!mobile) {
        this.$message({
          type: "warning",
          message: "手机号不能为空",
        });
        return;
      }

      if(this.flag){
        this.getCodeApi();
      }else{
        this.$message({
          message: '倒计时后才能重新获取！',
          offset:300,
          type: 'warning'
        });
      }
    },
    changeLoginType(){
      this.loginType = this.loginType==1?2:1;
      if(this.loginType == 1){
        this.$refs.ruleForm1.resetFields();
      }else{
        this.$refs.ruleForm.resetFields();
      }
    },
    getImgCodes(){
      this.timer = timestamp();
      this.imgCode = process.env.BASE_API + "/code/regCode?uid=" + this.timer;
    },
  },
  computed: {
    ...mapState(['LoginShow','RegisterShow']),
  },
  mounted(){
    this.getImgCodes();
    this.ruleForm.userName = this.$route.query.phone;
  },
  beforeDestroy(){
    clearInterval(this.interval);
  },
}
</script>

<style lang="less" scoped>
    .loginContainer{
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 80;
        min-height: 600px;
        .main{
            position: relative;
            margin: 0 auto;
            margin-top: calc( (100vh - 586px) / 2 );
            width: 698px;
            height: 586px;
            background: rgba(255,255, 255, 0.85);
            border-radius: 10px;
            overflow: hidden;
            .el-icon-close{
                position: absolute;
                top: 20px;
                right: 20px;
                font-size: 20px;
                color: #ADADAD;
                cursor: pointer;
            }
            .contFr{
                width: 100%;
                height: 100%;
                padding:106px 155px;
                .cahngeLogin{
                    font-size: 14px;
                    margin-top: 22px;
                    span{cursor: pointer;}
                    .fl{
                        color: #EB4B12;
                    }
                }
                .goLogin{
                  text-align: center;
                  margin-top: 30px;
                  display: inline-block;
                  width: 100%;
                  font-size: 12px;
                  height: 12px;
                  line-height: 12px;
                }
                .goLogin:hover{
                  color: #EB4B12;
                }
                .loginType{
                    margin-top: 20px;
                    text-align: center;
                    img{
                    margin: 0 31px;
                    cursor: pointer;
                    }
                }
                .orStyle{
                    color: #333;
                    display: block;
                    text-align: center;
                    width: 100%;
                    position: relative;
                    font-size: 12px;
                    line-height: 12px;
                }
                .orStyle::after{
                    content: "";
                    display: block;
                    width: 42%;
                    height: 1px;
                    background-color: #EB4B12;
                    position: absolute;
                    left: 0;
                    top: 5px;
                }
                .orStyle::before{
                    content: "";
                    display: block;
                    width: 42%;
                    height: 1px;
                    background-color: #EB4B12;
                    position: absolute;
                    right: 0;
                    top: 5px;
                }
                .optins{
                    a,span{
                    font-size: 12px;
                    cursor: pointer;
                    }
                    span{
                    color: #EB4B12;
                    }
                }
                .formItems1{
                    height: 44px;
                    position: relative;
                    margin-bottom: 0px;
                    background-color: transparent;
                    font-size: 0;
                    /deep/.el-form-item__content{height: 100%;}
                    .clearfix{
                        vertical-align: top;
                        width: 51%;
                        height: 100%;
                        background-color: transparent;
                        padding: 0px 12px 0px 10px;
                        display: inline-block;
                        border-bottom: 1px solid #999;
                        margin-right: 16%;
                        vertical-align: bottom;
                        float: left;
                        /deep/.el-input__inner{
                            background-color: transparent;
                        }
                    }
                }
                .formItems{
                    background-color: transparent;
                    padding: 0px 15px;
                    padding-left: 38px;
                    height: 44px;
                    position: relative;
                    border-bottom: 1px solid #999;
                    font-size: 0;
                    /deep/.el-input__inner{background-color: transparent;}
                    .iconfonts{
                        position: absolute;
                        bottom: 6px;
                        left: -38px;
                        height: 23px;
                    }
                }
                .agreement{
                    font-size: 12px;
                    color: #ff0000;
                }
                .agreement:hover{
                    color: rgb(72, 125, 240);
                    cursor: pointer;
                }
                .register{
                    width: 100%;
                    height: 50px;
                    border-radius: 3px;
                    background-color:#EB4B12;
                    border: 0;
                    color: #fff;
                    text-align: center;
                    line-height: 50px;
                    cursor: pointer;
                }
                .codeBox{
                    width: 32%;
                    height: 43px;
                    cursor: pointer;
                    vertical-align: bottom;
                    float: right;
                }
                .code{
                    font-size: 12px;
                    border: 0;
                    width: 32%;
                    vertical-align: bottom;
                    height:43px;
                    background-color: #EB4B12;
                    border-radius: 4px;
                    color: #fff;
                    display: inline-block;
                    text-align: center;
                }
            }
        }
    }
/deep/.el-input__inner{border: 0;}
    /* 设置带边框的checkbox，选中后边框的颜色 */
.myRedCheckBox.is-bordered.is-checked {
  border-color: #FF0000;
}

.myRedCheckBox .el-checkbox__input+.el-checkbox__label {
  font-size: 12px;
}
/* 设置选中后的文字颜色 */
.myRedCheckBox .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #FF0000;
}

/* 设置选中后对勾框的边框和背景颜色 */
.myRedCheckBox .el-checkbox__input.is-checked .el-checkbox__inner, .myRedCheckBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #FF0000;
  background-color:#FF0000;
}

/* 设置checkbox获得焦点后，对勾框的边框颜色 */
.myRedCheckBox .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #FF0000;
}

/* 设置鼠标经过对勾框，对勾框边框的颜色 */
.myRedCheckBox .el-checkbox__inner:hover{
  border-color: #FF0000;
}
</style>


// WEBPACK FOOTER //
// src/components/LoginPopup.vue